import { Stack, Typography } from "@mui/material";
import TestingStatus from "components/TestingStatus";
import dayjs from "dayjs";
import { Trial } from "../types";

interface TrialHistoryProps {
  trial: Trial;
}

const TrialHistory = ({ trial }: TrialHistoryProps) => (
  <Stack spacing={2}>
    {trial?.trialStatusHistory?.map((status) => (
      <Stack
        key={`trial-history-item-${status.id}`}
        direction='row'
        alignItems='center'
        justifyContent='end'
        spacing={2}
        sx={{
          width: "100%",
          backgroundColor: "bgSwitch",
          px: 2,
          py: 1.5,
        }}>
        <Typography variant='body16rg'>{dayjs(status.createdAt).format("DD.MM.YYYY HH:mm")}</Typography>
        <TestingStatus status={status.newStatus} />
      </Stack>
    ))}
  </Stack>
);

export default TrialHistory;
